export default __webpack_public_path__ + "static/media/IMG_4524-min.b1e696db.JPG";